<template>
  <div class="payment-container">
    <div class="payment-form">
      <div class="logo">
        <img src="../assets/logo.svg" alt="" />
      </div>
      <div class="payment-input">
        <label for="orderId">Введите номер заказа</label>
        <div class="row mx-0 payment-flex">
          <input
            type="number"
            :disabled="status !== 0"
            :class="{ empty: status === 0 }"
            v-model="form.order_id"
            id="orderId"
            class="col"
          />
          <button class="col-auto" @click="searchOrder" v-if="status === 0">
            <img src="../assets/search.svg" alt="" />
          </button>
        </div>
        <div class="payment-info">
          Для оплаты (ввода реквизитов Вашей карты) Вы будете перенаправлены на
          платежный шлюз ПАО СБЕРБАНК. Соединение с платежным шлюзом и передача
          информации осуществляется в защищенном режиме с использованием
          протокола шифрования SSL. В случае если Ваш банк поддерживает
          технологию безопасного проведения интернет-платежей Verified By Visa
          или MasterCard SecureCode для проведения платежа также может
          потребоваться ввод специального пароля. Настоящий сайт поддерживает
          256-битное шифрование. Конфиденциальность сообщаемой персональной
          информации обеспечивается ПАО СБЕРБАНК. Введенная информация не будет
          предоставлена третьим лицам за исключением случаев, предусмотренных
          законодательством РФ. Проведение платежей по банковским картам
          осуществляется в строгом соответствии с требованиями платежных систем
          МИР, Visa Int. и MasterCard Europe Sprl.
        </div>
      </div>
      <div v-if="order">
        <div class="item-list">
          <div
            class="item mb-2"
            v-for="item in order.items"
            :key="item.item_id"
          >
            <div class="row">
              <div class="col d-flex align-items-center">
                <span class="item-name">{{ item.item_name }}</span>
                <span class="item-count"> {{ item.count }} шт. </span>
              </div>
              <div class="col-auto" v-if="!item.gift">
                <span class="item-price">{{ parsePrice(item.sum) }} ₽</span>
              </div>
            </div>
          </div>
          <div class="item mb-2" v-if="order.manager_delivery_price > 0">
            <div class="row">
              <div class="col d-flex align-items-center">
                <span class="item-name">Доставка</span>
              </div>
              <div class="col-auto">
                <span class="item-price"
                  >{{ parsePrice(order.manager_delivery_price) }} ₽</span
                >
              </div>
            </div>
          </div>
          <div class="item mb-2" v-if="order.discount > 0">
            <div class="row">
              <div class="col d-flex align-items-center">
                <span class="item-name">Скидка</span>
              </div>
              <div class="col-auto">
                <span class="item-price"
                  >{{ parsePrice(order.discount) }} ₽</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="price">{{ parsePrice(order.price) }} ₽</div>
      </div>
      <div v-if="order && status === 2" class="payment-button">
        <button @click="startPayment">Перейти к оплате ➝</button>
      </div>
      <div v-if="status === 3" class="d-flex justify-content-center p-4">
        Перенаправление...
      </div>
    </div>
  </div>
  <div class="errors">
    <div class="error" :key="error" v-for="error in errors">
      {{ error }}
    </div>
  </div>
</template>

<script>
import { SEARCH_ORDER, START_PAYMENT } from "@/store/modules/pay";

export default {
  name: "IndexView",
  data() {
    return {
      status: 0,
      form: {
        order_id: "",
      },
      order: false,
      errors: [],
    };
  },
  methods: {
    searchOrder() {
      this.status = 1;
      this.errors = [];
      this.$store
        .dispatch(SEARCH_ORDER, this.form)
        .then((response) => {
          this.status = 2;
          this.order = response;
        })
        .catch(() => {
          this.status = 0;
          this.errors = ["Ошибка загрузки заказа"];
        });
    },
    startPayment() {
      this.status = 3;
      this.errors = [];
      this.$store.dispatch(START_PAYMENT, this.form).then((response) => {
        console.log(response);
        if (response.status === "start") window.location.href = response.url;
      });
    },
    parsePrice: function (str) {
      return parseFloat(str)
        .toString()
        .replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1 ");
    },
  },
};
</script>

<style lang="scss" scoped>
.payment-container {
  display: flex;
  justify-content: center;
  .payment-form {
    width: 100%;
    max-width: 500px;
    .logo {
      display: flex;
      justify-content: center;
      margin-top: 20px;
      margin-bottom: 30px;
    }
    .payment-input {
      label {
        text-transform: uppercase;
        font-weight: 700;
        font-size: 14px;
        color: #488eff;
        margin-bottom: 5px;
        display: block;
      }
      .payment-flex {
        //display: flex;
        input {
          //flex: 1 0 auto;
          //border: none;
          padding: 10px 15px;
          font-size: 25px;
          color: rgb(0 0 0);
          background: #fff;

          border-radius: 8px;

          &.empty {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          }

          /* purgecss start ignore */
          &::-webkit-outer-spin-button,
          &::-webkit-inner-spin-button {
            /* display: none; <- Crashes Chrome on hover */
            -webkit-appearance: none;
            margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
          }
          /* purgecss end ignore */

          &[type="number"] {
            -moz-appearance: textfield; /* Firefox */
          }

          &[disabled] {
            background: #ddd;
          }
        }
        button {
          //flex: 0 0 auto;
          //padding: 10px 15px;
          //font-size: 25px;
          border: none;
          color: rgb(255 255 255);
          background: #488eff;
          display: flex;
          justify-content: center;
          align-items: center;
          transition: 0.2s;

          border-top-right-radius: 8px;
          border-bottom-right-radius: 8px;

          img {
            height: 25px;
            padding: 0 25px;
            transition: 0.5s;
            transform: rotate(0deg) translateX(0px);

            &.animated {
              animation: orbit 2s linear infinite;
            }
          }

          &:hover:not([disabled]) {
            cursor: pointer;
            background: #1964e7;
          }

          &[disabled] {
            background: #7a9bd0;
            //background: #ddd;

            img {
              //display: none;
            }
          }
        }
      }
    }

    .item-list {
      margin-top: 20px;
      .item {
        background: #2c2c2c;
        padding: 15px;
        border-radius: 5px;
        color: #fff;

        .item-name {
          font-weight: 600;
        }
        .item-count {
          background: #488eff;
          margin-left: 5px;
          color: #fff;
          font-size: 12px;
          padding: 1px 7px;
          border-radius: 5px;
          font-weight: 600;
        }
        .item-price {
          font-size: 20px;
          font-weight: 600;
          color: #488eff;
        }
      }
    }

    .price {
      font-size: 40px;
      font-weight: 600;
      text-align: center;
      margin-top: 20px;
      color: #488eff;
    }

    .payment-button {
      display: flex;
      justify-content: center;
      margin-top: 20px;
      button {
        border: none;
        color: rgb(255 255 255);
        background: #488eff;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: 0.2s;
        padding: 15px 45px;
        font-size: 20px;

        &:hover {
          background: #1964e7;
        }
      }
    }
  }
}

.errors {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: red;
  padding: 20px;

  .error {
    color: #fff;
    text-align: center;
    font-size: 18px;
  }

  &:empty {
    display: none;
  }
}

@keyframes orbit {
  from {
    transform: rotate(360deg) translateX(2px) rotate(-360deg);
  }
  to {
    transform: rotate(0deg) translateX(2px) rotate(0deg);
  }
}

.payment-info {
  font-size: 12px;
  color: #8d8d8d;
  margin-top: 10px;
  border: 1px solid #464646;
  padding: 10px 15px;
  border-radius: 10px;
}
</style>
